import { ArticleParagraph2 } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './styles.css';
import commonColumnStyles from '../common-column-styles.css';

export const HeaderRow: FC = () => {
  return (
    <div className={styles['row']}>
      <span className={commonColumnStyles['common-title-col']}>
        <ArticleParagraph2 color="gray40_100">Банки и застройщики</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-rate-col']}>
        <ArticleParagraph2 color="gray40_100">Ставка</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-sum-col']}>
        <ArticleParagraph2 color="gray40_100">Сумма</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-term-col']}>
        <ArticleParagraph2 color="gray40_100">Срок</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-payment-col']}>
        <ArticleParagraph2 color="gray40_100" textAlign="right">
          Ежемесячный платёж
        </ArticleParagraph2>
      </span>
    </div>
  );
};
